import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const LOGO = (
  <img src="/assets/img/logo.svg" alt="G-Museum" className="logo-svg" />
);

const MENU_ITEMS = [
  { id: 'istoriya', label: 'Історія G-Museum' },
  { id: 'godini', label: 'Години роботи музею' },
  { id: 'kontakty', label: 'Контакти' },
];

const TICKETS_MENU = [
  { to: '/', label: 'Повернутись на головну' },
];

export default function Header() {
  const location = useLocation();
  const isTickets = location.pathname === '/tickets';
  const headers = useRef([null, null]);

  useEffect(() => {
    const mm = document.querySelector('.main-menu');
    const mob = document.querySelector('.mobile-menu');
    headers.current = [mm, mob];

    let lastDir = 0;
    ScrollTrigger.create({
      start: 0,
      end: 'max',
      onUpdate: (self) => {
        const dir = self.direction;
        if (dir === lastDir) return;
        lastDir = dir;
        gsap.to(headers.current.filter(Boolean), {
          yPercent: dir === 1 ? -100 : 0,
          duration: 0.45,
          ease: 'power3.out',
          overwrite: true,
        });
      },
    });

    return () => {
      // ScrollTrigger cleanup handled by unmount
    };
  }, []);

  const scrollTo = (id) => (e) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="main-menu js-scroll-hide">
      <div className="main-menu-logo">
        <a href="/" className="logotype" aria-label="G-Museum, inicio">
          {LOGO}
        </a>
      </div>
      <nav className="main-menu-wrap" aria-label="Navegación principal">
        {isTickets ? (
          TICKETS_MENU.map((item) => (
            <div key={item.to} className="main-menu-item">
              <a href={item.to} style={{ textDecoration: 'none', color: '#fff' }}>
                {item.label}
              </a>
            </div>
          ))
        ) : (
          <>
            {MENU_ITEMS.map((item) => (
              <div key={item.id} className="main-menu-item">
                <a href={`#${item.id}`} onClick={scrollTo(item.id)} className="main-menu-link">
                  {item.label}
                </a>
              </div>
            ))}
            <div className="main-menu-item">
              <a href="/tickets">Купити квиток</a>
            </div>
          </>
        )}
      </nav>
    </header>
  );
}
